import React, { useEffect, useState } from 'react'
import {
	Box,
	Select,
	Stack,
	Input,
	HStack,
	IconButton,
	Spinner,
	Center,
	Text,
	Alert,
	Icon,
	Collapse,
	Button,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Image,
	VStack,
	Flex,
	SimpleGrid,
} from '@chakra-ui/react'
import {
	Pagination,
	usePagination,
	PaginationNext,
	PaginationPage,
	PaginationPrevious,
	PaginationContainer,
	PaginationPageGroup,
	PaginationSeparator,
} from '@ajna/pagination'
import AdminBusinessCard from '../components/AdminBusinessCard'
import { GoSearch } from 'react-icons/go'
import { getRequest } from '../services/base.service'
import { IoIosArrowBack } from 'react-icons/io'
import { IoIosArrowForward } from 'react-icons/io'
import { FiFilter, FiEye } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
	setAdminSidebarFalseOnUrlChange,
	setCurrentPageHeading,
} from '../redux/common/commonActions'
import FrontendBlockCard from '../components/FrontendBlockCard'
import UserBusinessCard from '../components/UserBusinessCard'
import SearchBox from '../components/SearchBox'

const UserBusinessList = () => {
	const [businessList, setBusinessList] = useState(null)
	const [showMobileActions, setShowMobileActions] = useState(false)
	const [paginationProperty, setPaginationProperty] = useState({
		total: 1,
		currentPage: 1,
		pageSize: 10,
	})
	const [spinner, setSpinner] = useState({ status: true })
	const [selectedCountry, setSelectedCountry] = useState(null)
	const [countryList, setCountryList] = useState([])
	const [stateList, setStateList] = useState([])
	const [industryList, setIndustryList] = useState([])
	const [queryParams, setQueryParams] = useState({
		sort: '',
	})
	const {
		pages,
		pagesCount,
		currentPage,
		setCurrentPage,
		isDisabled,
		setPageSize,
		pageSize
	} = usePagination({
		total: paginationProperty.total,
		limits: {
			outer: 2,
			inner: 2,
		},
		initialState: {
			pageSize: paginationProperty.pageSize,
			isDisabled: false,
			currentPage: 1,
		},
	})
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(setCurrentPageHeading('Business List'))
		dispatch(setAdminSidebarFalseOnUrlChange())
		// fetchAllStateList()
		// fetchCityList()
	}, [])

	useEffect(() => {
		fetchBusinessList({ page: currentPage, limit: pageSize })
		fetchCountryList()
		fetchIndustryList()
	}, [currentPage, pageSize])

	useEffect(() => {
			if (selectedCountry) {
				fetchStateList();
			}
	}, [selectedCountry])

	const fetchBusinessList = (params = {}) => {
		setSpinner({ status: true })
		getRequest('user/businesses', { params })
			.then((res) => {
				setBusinessList(res.result?.data)
				setPaginationProperty({
					total: res.result.total,
					currentPage: res.result.current_page,
					pageSize: res.result.per_page,
				})
				setPageSize(res.result.per_page)
				setSpinner({ status: false })
			})
			.catch((err) => {
				console.log('ERR: ', err)
			})
	}

	const fetchStateList = () => {
			getRequest(`states/${selectedCountry}`)
				.then((res) => {
					setStateList(res.result?.states)
					console.log('State List: ', res.result?.states)
				})
				.catch((err) => {
					console.log('ERR: ', err)
				})
	}

	const fetchCountryList = () => {
				getRequest(`countries`)
					.then((res) => setCountryList(res.result))
					.catch((err) => console.log('ERR: ', err))
	}

	const fetchIndustryList = () => {
				getRequest(`industry-list`)
					.then((res) => setIndustryList(res.result))
					.catch((err) => console.log('ERR: ', err))
	}

	const handlePageChange = (nextPage) => {
		setCurrentPage(nextPage)
	}

	const handleSearch = (e) => {
		e.preventDefault()
		setCurrentPage(1)
		fetchBusinessList({ ...queryParams, page: 1, limit: pageSize })
	}

	function handleChange(key, event) {
		setQueryParams({ ...queryParams, [key]: event.target.value })
		setSpinner({ status: true })
		setCurrentPage(1)
		fetchBusinessList({ ...queryParams, [key]: event.target.value, page: 1 })
	}
	const formatDate = (dateString) => {
			const date = new Date(dateString);
			const day = date.getDate();
			const month = date.toLocaleString('en-GB', { month: 'long' });
			const year = date.getFullYear();
			return `${day} ${month}, ${year}`;
	};
	const handleReset = () => {
		const defaultQuery = { keyword: '', country_id: '', state_id: '', industry_id: '', status: '', sort: '', address_keyword: '' }
		setQueryParams(defaultQuery)
		setCurrentPage(1)
		fetchBusinessList({ ...defaultQuery, page: 1 })
	}

	return (
		<>
			<Box py={'7'} px={['2', '2', '5', '10']}>
				<SearchBox
					primaryActions={
						<>
							<HStack as={'form'} w="100%">
										<Input
											placeholder="Search..."
											w={['100%']} 
											size={'md'}
											borderColor={'gray.300'}
											rounded={'md'}
											onChange={(e) => {
												setQueryParams({
													...queryParams,
													keyword: e.target.value,
												})
											}}
										/>
							</HStack>
						</>
					}
					secondaryActions={
						<VStack as="form" spacing={4} w="100%" align="stretch">
							<SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} w="100%">
							<Select
								placeholder="Country"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.country_id || ''}
								// onChange={(e) => handleChange('country_id', e)}
								onChange={(e) => {
												setQueryParams({
													...queryParams,
													country_id: e.target.value,
												})
												setSelectedCountry(e.target.value)
								}}
							>
								{countryList.map((country) => (
								<option key={country.id} value={country.id}>
									{country.name}
								</option>
								))}
							</Select>
						
							<Select
								placeholder="State"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.state_id || ''}
								// onChange={(e) => handleChange('state_id', e)}
								onChange={(e) => {
												setQueryParams({
													...queryParams,
													state_id: e.target.value,
												})
								}}
							>
								{stateList.map((state) => (
								<option key={state.id} value={state.id}>
									{state.name}
								</option>
								))}
							</Select>
						
							<Input
								placeholder="Enter Area"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.address_keyword || ''}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										address_keyword: e.target.value,
									})
								}
							/>
						
							<Select
								placeholder="Industry"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.industry_id || ''}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										industry_id: e.target.value,
									})
								}
							>
								{industryList.map((industry) => (
								<option key={industry.id} value={industry.id}>
									{industry.name}
								</option>
								))}
							</Select>
						
							<Select
								placeholder="Status"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.status || ''}
								// onChange={(e) => handleChange('status', e)}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										status: e.target.value,
									})
								}
							>
								<option value="pending">Pending</option>
								<option value="approved">Approved</option>
								<option value="declined">Declined</option>
								<option value="blocked">Blocked</option>
							</Select>
						
							<Select
								placeholder="Sort By"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.sort || ''}
								// onChange={(e) => handleChange('sort', e)}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										sort: e.target.value,
									})
								}
							>
								<option value="desc">New</option>
								<option value="asc">Older</option>
							</Select>
							</SimpleGrid>
						
							{/* Buttons */}
							<HStack justify="flex-end" spacing={4}>

								<Button 
									variant="outline"
									colorScheme="gray" 
									size="md"				
									rounded={'md'}
									onClick={handleReset}
								>
									Reset
								</Button>
								<Button 
									variant={'brand'}
									size="md"
									rounded={'md'}
									type="submit" 
									onClick={handleSearch}
								>
									Search
								</Button>
							</HStack>
						</VStack>
					}
				>
				</SearchBox>			
				<FrontendBlockCard
					title={
						<HStack spacing={3}>
						<Box>Business List</Box>
						<Button
												as={Link}
												to={`/business/create`}
												size={'sm'}
												w={'100px'}
												variant={'brand'}
												ml={['0', '0', '2', '0']}
											>
												Add New
											</Button>
					  </HStack>
					}
					// actions={
					// 	<>
					// 		<HStack>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Filter By"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.status}
					// 				onChange={(e) => handleChange('status', e)}
					// 			>
					// 				<option value={'pending'}>Pending</option>
					// 				<option value={'approved'}>Approved</option>
					// 				<option value={'declined'}>Declined</option>
					// 				<option value={'blocked'}>Blocked</option>
					// 			</Select>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Sort By"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.sort}
					// 				onChange={(e) => handleChange('sort', e)}
					// 			>
					// 				<option value={'desc'}>New</option>
					// 				<option value={'asc'}>Older</option>
					// 			</Select>
					// 			<HStack as={'form'}>
					// 				<Input
					// 					placeholder="Search..."
					// 					w={['100%', '100%', '100%', '120px']}
					// 					size={'sm'}
					// 					borderColor={'gray.300'}
					// 					onChange={(e) => {
					// 						setQueryParams({
					// 							...queryParams,
					// 							keyword: e.target.value,
					// 						})
					// 					}}
					// 				/>

					// 				<Box>
					// 					<IconButton
					// 						aria-label="Search"
					// 						size={'sm'}
					// 						icon={<GoSearch />}
					// 						variant={'brand'}
					// 						type="submit"
					// 						onClick={handleSearch}
					// 					/>
					// 				</Box>
					// 			</HStack>
					// 			<Icon
					// 				as={FiFilter}
					// 				display={[
					// 					'inline-block',
					// 					'inline-block',
					// 					'inline-block',
					// 					'none',
					// 				]}
					// 				onClick={() => {
					// 					setShowMobileActions(!showMobileActions)
					// 				}}
					// 				_hover={{ cursor: 'pointer' }}
					// 			/>
					// 		</HStack>
					// 	</>
					// }
					// mobileActions={
					// 	<Collapse
					// 		in={showMobileActions}
					// 		unmountOnExit={true}
					// 		animateOpacity
					// 	>
					// 		<HStack
					// 			display={[
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				'none',
					// 			]}
					// 			transition={'2s'}
					// 		>
					// 			<Select
					// 				placeholder="Filter By"
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.status}
					// 				onChange={(e) => handleChange('status', e)}
					// 			>
					// 				<option value={'pending'}>Pending</option>
					// 				<option value={'approved'}>Approved</option>
					// 				<option value={'declined'}>Declined</option>
					// 				<option value={'blocked'}>Blocked</option>
					// 			</Select>
					// 			<Select
					// 				placeholder="Sort By"
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.sort}
					// 				onChange={(e) => handleChange('sort', e)}
					// 			>
					// 				<option value={'desc'}>New</option>
					// 				<option value={'asc'}>Older</option>
					// 			</Select>
					// 		</HStack>
					// 	</Collapse>
					// }
				>
					{spinner.status ? (
						<Center>
							<Spinner color="red.500" size="xl" speed="0.6s" />
						</Center>
					) : businessList.length > 0 ? (
						<>
							<Stack gap={2} rounded={'md'} overflow={'auto'} border={'1px'} borderColor="gray.200">
								{/* {businessList?.map((business, index) => (
									<UserBusinessCard
										key={index}
										companyName={business?.name}
										data={business}
									/>
								))} */}
								<Table
									variant="simple"
									w={'100%'}
								>
									<Thead bg="gray.100">
										<Tr>
											<Th>Logo</Th>
											<Th>Id</Th>
											<Th>Name</Th>
											<Th>Address</Th>
											<Th>Created</Th>
											<Th> Last Updated</Th>
											<Th>Status</Th>
											<Th textAlign="right">Actions</Th>
										</Tr>
									</Thead>
									<Tbody>
										{businessList.map((business, index) => (
											<Tr key={business.id} bg={index % 2 === 0 ? 'gray.50' : 'white'}>
												<Td>
													<Image
														src={business.logo}
														alt={business.name}
														boxSize="50px"
														objectFit="contain"
													/>
												</Td>
												<Td>{business.id}</Td>
												<Td>{business.name}</Td>
												<Td>{[
													business?.city?.name,
													business?.state?.name,
													business?.country?.name
													].filter(Boolean).join(', ')}
												</Td>
												<Td>{formatDate(business.created_at)}</Td>
												<Td>{formatDate(business.updated_at)}</Td>
												<Td>{business.status}</Td>
												<Td key={business.id}>
													<HStack
														textAlign="right"
														align="right"
														justify="right"
														gap={2}
													>
														<Link to={`/business/${business.id}`}>
															<FiEye cursor="pointer" />
														</Link>													
													</HStack>
												</Td>												
											</Tr>
										))}
									</Tbody>									
								</Table>
							</Stack>
							<Flex justify="space-between" align="center" mt={4} px={2} flexWrap="wrap" gap={2}>
							<HStack>
								<Select
									size="sm"
									width="fit-content"
									rounded="md"
									value={paginationProperty.pageSize}
									onChange={(e) => {
										setPageSize(Number(e.target.value));
										setCurrentPage(1);
									}}
								>
									{[10, 20, 50, 100].map((size) => (
										<option key={size} value={size}>
										{size}
										</option>
									))}
								</Select>
								<Text fontSize="sm" color="gray.600">
								Viewing {(currentPage - 1) * paginationProperty.pageSize + 1} to{' '}
								{Math.min(currentPage * paginationProperty.pageSize, paginationProperty.total)} of{' '}
								{paginationProperty.total} data
								</Text>
							</HStack>
							<Pagination
								pagesCount={pagesCount}
								currentPage={currentPage}
								isDisabled={isDisabled}
								onPageChange={handlePageChange}
							>
								<PaginationContainer align="center" justify="center" p={4}>
									<PaginationPrevious
										px={'2'}
										_hover={{
											bg: 'gray.100',
										}}
										bg="white"
										color="gray.700"
										_disable={{ bg: 'white' }}
									>
										<Text>
											<IoIosArrowBack />
										</Text>
									</PaginationPrevious>
									<PaginationPageGroup
										isInline
										align={'center'}
										mx={'1'}
										separator={
											<PaginationSeparator fontSize="sm" w={7} jumpSize={11} />
										}
									>
										{pages.map((page) => (
											<PaginationPage
												w={7}
												h={7}
												bg={'gray.200'}
												border={'1px'}
												borderColor={'gray.300'}
												key={`pagination_page_${page}`}
												page={page}
												color={'black.500'}
												fontSize={'sm'}
												_hover={{
													bg: 'brand.600',
													color: 'white',
												}}
												_current={{
													bg: 'brand.500',
													fontSize: 'sm',
													color: 'white',
													borderColor: 'brand.500',
												}}
											/>
										))}
									</PaginationPageGroup>
									<PaginationNext
										w={7}
										h={7}
										_hover={{
											bg: 'gray.100',
										}}
										bg="white"
										color="gray.700"
										_disable={{ bg: 'white' }}
									>
										<Text>
											<IoIosArrowForward />
										</Text>
									</PaginationNext>
								</PaginationContainer>
							</Pagination>
							</Flex>
						</>
					) : (
						<Alert status="error">
							<Center h={'100%'} w={'100%'}>
								NO DATA FOUND.
							</Center>
						</Alert>
					)}
				</FrontendBlockCard>
			</Box>
		</>
	)
}

export default UserBusinessList
